import Container from './Container';
import View from './View';

export * from './components';
export * from './utils';

export default Container(View);
